import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import ClientLayout from '../../layouts/ClientLayout';

const Categories = () => {
  // État pour les filtres
  const [selectedCategory, setSelectedCategory] = useState('Électronique');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [priceRange, setPriceRange] = useState({ min: 0, max: 95000 });
  const [selectedColors, setSelectedColors] = useState([]);
  const [sortBy, setSortBy] = useState('recent');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(6); // 6 produits par page (2x3 grille)

  // Données des catégories avec sous-catégories
  const categories = [
    {
      name: 'Électronique',
      count: 156,
      checked: true,
      expanded: false,
      subcategories: [
        { name: 'Smartphones', count: 45 },
        { name: 'Ordinateurs', count: 32 },
        { name: 'Accessoires', count: 79 }
      ]
    },
    {
      name: 'Mode et accessoires',
      count: 25,
      expanded: false,
      subcategories: [
        { name: 'Vêtements', count: 12 },
        { name: 'Chaussures', count: 8 },
        { name: 'Accessoires', count: 5 }
      ]
    },
    {
      name: 'Épicerie et fruits',
      count: 412,
      expanded: false,
      subcategories: [
        { name: 'Fruits frais', count: 156 },
        { name: 'Légumes', count: 89 },
        { name: 'Céréales', count: 167 }
      ]
    },
    {
      name: 'Santé et bien-être',
      count: 81,
      expanded: false,
      subcategories: [
      ]
    },
    {
      name: 'Maison et meubles',
      count: 32,
      expanded: false,
      subcategories: [
      ]
    },
    {
      name: 'Ménage et essentiels',
      count: 34,
      expanded: false,
      subcategories: [
        { name: 'Produits ménagers', count: 22 },
        { name: 'Outils', count: 12 }
      ]
    },
    {
      name: 'Bijoux',
      count: 81,
      expanded: false,
      subcategories: [
      ]
    },
    {
      name: 'Jouets et jeux vidéo',
      count: 8,
      expanded: false,
      subcategories: [
        { name: 'Jouets', count: 5 },
        { name: 'Jeux vidéo', count: 3 }
      ]
    },
    {
      name: 'Patio et jardin',
      count: 25,
      expanded: false,
      subcategories: [
        { name: 'Plantes', count: 15 },
        { name: 'Outils jardinage', count: 10 }
      ]
    },
    {
      name: 'Animaux de compagnie',
      count: 412,
      expanded: false,
      subcategories: [
        { name: 'Nourriture', count: 234 },
        { name: 'Accessoires', count: 178 }
      ]
    },
    {
      name: 'Sport et plein air',
      count: 81,
      expanded: false,
      subcategories: [
        { name: 'Équipements', count: 45 },
        { name: 'Vêtements sport', count: 36 }
      ]
    },
    {
      name: 'Bébé et enfants',
      count: 32,
      expanded: false,
      subcategories: [
        { name: 'Vêtements bébé', count: 18 },
        { name: 'Jouets bébé', count: 14 }
      ]
    }
  ];

  // Données des couleurs
  const colors = [
    { name: 'Noir', count: 1, color: 'bg-black' },
    { name: 'Bleu', count: 3, color: 'bg-blue-500' },
    { name: 'Brun', count: 2, color: 'bg-yellow-700' },
    { name: 'Vert', count: 2, color: 'bg-green-500' },
    { name: 'Gris', count: 1, color: 'bg-gray-500' },
    { name: 'Rose', count: 2, color: 'bg-pink-500' },
    { name: 'Titane', count: 2, color: 'bg-gray-400' }
  ];

  // Données des produits
  const products = [
    {
      id: 1,
      image: "/images/product1.jpg",
      type: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      oldPrice: 78000,
      newPrice: 41500,
      discount: 75,
      rating: 4,
      reviews: 85,
      seller: "Mobidas Sarl",
      color: "Noir"
    },
    {
      id: 2,
      image: "/images/product2.jpg",
      type: "Meuble",
      name: "Masque de culture",
      oldPrice: 18000,
      newPrice: 14500,
      discount: 25,
      rating: 5,
      reviews: 42,
      seller: "Artisan Plus",
      color: "Brun"
    },
    {
      id: 3,
      image: "/images/product3.jpg",
      type: "Meuble",
      name: "Chaise d'intérieur",
      oldPrice: 200000,
      newPrice: 120500,
      discount: 40,
      rating: 4,
      reviews: 67,
      seller: "Mobidas Sarl",
      color: "Gris"
    },
    {
      id: 4,
      image: "/images/product4.jpg",
      type: "Artisanat",
      name: "Sculpture en bois",
      oldPrice: 5000,
      newPrice: 1500,
      discount: 70,
      rating: 5,
      reviews: 23,
      seller: "Artisan Plus",
      color: "Brun"
    },
    {
      id: 5,
      image: "/images/product5.jpg",
      type: "Meuble",
      name: "Canapé moderne",
      oldPrice: 150000,
      newPrice: 95000,
      discount: 37,
      rating: 4,
      reviews: 89,
      seller: "Mobidas Sarl",
      color: "Beige"
    },
    {
      id: 6,
      image: "/images/product6.jpg",
      type: "Électronique",
      name: "Mixeur professionnel",
      oldPrice: 25000,
      newPrice: 18000,
      discount: 28,
      rating: 5,
      reviews: 156,
      seller: "TechStore",
      color: "Rouge"
    }
  ];

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedSubcategory(''); // Reset subcategory when main category changes
  };

  const handleSubcategoryChange = (subcategoryName) => {
    setSelectedSubcategory(subcategoryName);
  };

  const toggleCategoryExpansion = (categoryName) => {
    setExpandedCategories(prev =>
      prev.includes(categoryName)
        ? prev.filter(cat => cat !== categoryName)
        : [...prev, categoryName]
    );
  };

  const handleColorChange = (colorName) => {
    setSelectedColors(prev =>
      prev.includes(colorName)
        ? prev.filter(c => c !== colorName)
        : [...prev, colorName]
    );
  };

  // Logique de pagination
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentProducts = products.slice(startIndex, endIndex);
  const totalProducts = products.length;

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll vers le haut de la grille de produits
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`w-4 h-4 ${index < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
        {/* Fil d'Ariane */}
        <div className="mb-4">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Toutes les catégories</span>
          </nav>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Barre latérale - Filtres */}
          <div className="lg:col-span-1">
            <div className="bg-white sticky top-8">
              {/* Catégories */}
              <div className="mb-8">
                <h3 className="font-bold text-gray-900 mb-4">Catégories de produits</h3>
                <div className="space-y-1 max-h-64 overflow-y-auto pr-2">
                  {categories.map((category) => (
                    <div key={category.name}>
                      <label className="flex items-center justify-between cursor-pointer hover:bg-gray-50 py-2 px-2 rounded">
                        <div className="flex items-center flex-1">
                          <input
                            type="checkbox"
                            checked={selectedCategory === category.name}
                            onChange={() => handleCategoryChange(category.name)}
                            className="mr-3 text-white accent-orange-light"
                          />
                          <span className={`text-sm ${selectedCategory === category.name ? 'text-orange-hover font-medium' : 'text-gray-700'}`}>
                            {category.name}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className="text-gray-500 text-xs">({category.count})</span>
                          {category.subcategories && category.subcategories.length > 0 && (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                toggleCategoryExpansion(category.name);
                              }}
                              className="p-1 hover:bg-gray-100 rounded"
                            >
                              <svg
                                className={`w-3 h-3 text-gray-500 transition-transform ${expandedCategories.includes(category.name) ? 'rotate-90' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </label>

                      {/* Sous-catégories */}
                      {expandedCategories.includes(category.name) && category.subcategories && category.subcategories.length > 0 && (
                        <div className="ml-6 space-y-1">
                          {category.subcategories.map((subcategory) => (
                            <label key={subcategory.name} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 py-1 px-2 rounded">
                              <div className="flex items-center">
                                <input
                                  type="checkbox"
                                  checked={selectedSubcategory === subcategory.name}
                                  onChange={() => handleSubcategoryChange(subcategory.name)}
                                  className="mr-3 text-white accent-orange-light"
                                />
                                <span className={`text-xs ${selectedSubcategory === subcategory.name ? 'text-orange-hover font-medium' : 'text-gray-600'}`}>
                                  {subcategory.name}
                                </span>
                              </div>
                              <span className="text-gray-400 text-xs">({subcategory.count})</span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Filtre de prix */}
              <div className="mb-8">
                <h3 className="font-bold text-gray-900 mb-4">Filtre de prix du widget</h3>
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-2">
                    <input
                      type="number"
                      min={0}
                      placeholder="Prix minimum"
                      value={priceRange.min}
                      onChange={(e) => setPriceRange(prev => ({ ...prev, min: parseInt(e.target.value) || 0 }))}
                      className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    />
                    <input
                      type="number"
                      min={0}
                      placeholder="Prix maximum"
                      value={priceRange.max}
                      onChange={(e) => setPriceRange(prev => ({ ...prev, max: parseInt(e.target.value) || 0 }))}
                      className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    />
                  </div>
                  <div className="text-sm text-gray-600">
                    Prix : {priceRange.min.toLocaleString()} FCFA - {priceRange.max.toLocaleString()} FCFA
                  </div>
                  <button className="w-full bg-orange-hover text-white py-2 px-4 rounded-lg hover:bg-orange-700 transition-colors">
                    Filtre
                  </button>
                </div>
              </div>

              {/* Filtre par couleur */}
              <div className="mb-8">
                <h3 className="font-bold text-gray-900 mb-4">Filtrer par couleur</h3>
                <div className="space-y-2 max-h-48 overflow-y-auto pr-2">
                  {colors.map((color) => (
                    <label key={color.name} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={selectedColors.includes(color.name)}
                          onChange={() => handleColorChange(color.name)}
                          className="mr-3 text-orange-light focus:ring-orange-light border-orange-light"
                        />
                        <div className={`w-4 h-4 rounded-full ${color.color} mr-3`}></div>
                        <span className="text-gray-700">{color.name}</span>
                      </div>
                      <span className="text-gray-500 text-sm">({color.count})</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Grille de produits */}
          <div className="lg:col-span-3">
            {/* En-tête avec options */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
              <h2 className="text-gray-900 mb-4 sm:mb-0">
                Affichage des {products.length} résultats
              </h2>
              <div className="flex items-center space-x-4">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-orange-light focus:border-transparent"
                >
                  <option value="recent">Produits les plus récents</option>
                  <option value="price-low">Prix croissant</option>
                  <option value="price-high">Prix décroissant</option>
                  <option value="popular">Plus populaires</option>
                </select>
                <div className="flex space-x-2">
                  <button className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                    </svg>
                  </button>
                  <button className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Grille de produits */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {currentProducts.map((product) => (
                <div key={product.id} className="bg-white rounded-lg shadow-sm border hover:shadow-lg transition-shadow">
                  {/* Image du produit */}
                  <div className="relative">
                    <Link to={`/product/${product.id}`}>
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-48 object-cover rounded-t-lg cursor-pointer"
                        onError={(e) => {
                          e.target.src = "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
                        }}
                      />
                    </Link>
                    <button className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-md hover:bg-gray-50">
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </button>
                  </div>

                  {/* Contenu du produit */}
                  <div className="p-4">
                    <div className="text-sm text-orange-hover font-medium mb-1">{product.type}</div>
                    <Link to={`/product/${product.id}`} className="block">
                      <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2 hover:text-orange-hover transition-colors cursor-pointer">{product.name}</h3>
                    </Link>

                    {/* Prix */}
                    <div className="flex items-center space-x-2 mb-2">
                      <span className="text-lg font-bold text-gray-900">
                        {product.newPrice.toLocaleString()} Fcfa
                      </span>
                      <span className="text-sm text-gray-500 line-through">
                        {product.oldPrice.toLocaleString()} Fcfa
                      </span>
                      <span className="text-sm bg-red-100 text-red-600 px-2 py-1 rounded">
                        -{product.discount}%
                      </span>
                    </div>

                    {/* Évaluation */}
                    <div className="flex items-center space-x-2 mb-2">
                      <div className="flex">
                        {renderStars(product.rating)}
                      </div>
                      <span className="text-sm text-gray-600">({product.reviews} avis clients)</span>
                    </div>

                    {/* Vendeur */}
                    <div className="text-sm text-gray-600 mb-4">{product.seller}</div>

                    {/* Bouton ajouter au panier */}
                    <button
                      className="w-full py-2 px-4 rounded-full transition-colors flex items-center justify-center gap-2 bg-white text-black border border-gray-800 hover:border-0 hover:bg-gray-50 hover:bg-orange-hover hover:text-white"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="21.283" height="21.283" viewBox="0 0 21.283 21.283" className="transition-colors">
                        <g transform="translate(0.75 0.75)">
                          <path d="M1148.968,58.484A1.484,1.484,0,1,1,1147.484,57,1.483,1.483,0,0,1,1148.968,58.484Z" transform="translate(-1140.064 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
                          <path d="M1157.968,58.484A1.484,1.484,0,1,1,1156.484,57,1.483,1.483,0,0,1,1157.968,58.484Z" transform="translate(-1140.162 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
                          <path d="M1143.957,41.978h11.87a3.956,3.956,0,0,1,3.957,3.957v4.946a3.956,3.956,0,0,1-3.957,3.957h-7.913a3.956,3.956,0,0,1-3.956-3.957Zm0,0A1.981,1.981,0,0,0,1141.978,40H1140m3.957,5.935h15.332" transform="translate(-1140 -40)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                        </g>
                      </svg>
                      Ajouter en ligne
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center mt-8">
              <Pagination
                current={currentPage}
                total={totalProducts}
                pageSize={pageSize}
                onChange={handlePageChange}
                showSizeChanger={false}
                className="text-orange-hover"
              />
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default Categories; 